"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var url_1 = __importDefault(require("url"));
var env_1 = require("../../env");
var network_1 = __importDefault(require("../../network"));
var helpers_1 = require("../helpers");
var baseURL = function () { return (0, env_1.getEnv)("LEDGER_COUNTERVALUES_API"); };
var latest = function (pairs, direct) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, network_1["default"])({
                    method: "POST",
                    url: "".concat(baseURL(), "/latest").concat(direct ? "?method=direct" : ""),
                    data: pairs.map(function (p) {
                        var _a, _b;
                        return ({
                            from: (_a = p.from.countervalueTicker) !== null && _a !== void 0 ? _a : p.from.ticker,
                            to: (_b = p.to.countervalueTicker) !== null && _b !== void 0 ? _b : p.to.ticker
                        });
                    })
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
var api = {
    fetchHistorical: function (granularity, _a) {
        var from = _a.from, to = _a.to, startDate = _a.startDate;
        return __awaiter(void 0, void 0, void 0, function () {
            var format, query, fromTicker, toTicker, data;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        format = helpers_1.formatPerGranularity[granularity];
                        query = {};
                        if (startDate) {
                            query.start = format(startDate);
                        }
                        if (to.type !== "FiatCurrency") {
                            // for anything else than fiat, we use direct
                            query.method = "direct";
                        }
                        fromTicker = (_b = from.countervalueTicker) !== null && _b !== void 0 ? _b : from.ticker;
                        toTicker = (_c = to.countervalueTicker) !== null && _c !== void 0 ? _c : to.ticker;
                        return [4 /*yield*/, (0, network_1["default"])({
                                method: "GET",
                                url: url_1["default"].format({
                                    pathname: "".concat(baseURL(), "/").concat(granularity, "/").concat(fromTicker, "/").concat(toTicker),
                                    query: query
                                })
                            })];
                    case 1:
                        data = (_d.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    },
    fetchLatest: function (pairs) { return __awaiter(void 0, void 0, void 0, function () {
        var directP, indirectP, _a, direct, indirect, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    directP = [];
                    indirectP = [];
                    pairs.forEach(function (p) {
                        if (p.to.type !== "FiatCurrency") {
                            directP.push(p);
                        }
                        else {
                            indirectP.push(p);
                        }
                    });
                    return [4 /*yield*/, Promise.all([
                            directP.length ? latest(directP, true) : Promise.resolve([]),
                            indirectP.length ? latest(indirectP) : Promise.resolve([]),
                        ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 2]), direct = _a[0], indirect = _a[1];
                    data = Array(pairs.length).fill(0);
                    directP.forEach(function (p, i) {
                        data[pairs.indexOf(p)] = direct[i];
                    });
                    indirectP.forEach(function (p, i) {
                        data[pairs.indexOf(p)] = indirect[i];
                    });
                    return [2 /*return*/, data];
            }
        });
    }); },
    fetchMarketcapTickers: function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, network_1["default"])({
                        method: "GET",
                        url: "".concat(baseURL(), "/v2/tickers")
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); }
};
exports["default"] = api;
//# sourceMappingURL=api.js.map